<template>
  <div @click="nav">
    <img
      class="address"
      src="../assets/nav-videos/ann-arbor/topbar.png"
      alt="top bar address input"
    />
    <video muted autoplay playsinline>
      <source src="../assets/video/directions/annarbor.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: "Nav",
  methods: {
    nav() {
      this.$router.push("/home");
    }
  }
};
</script>

<style lang="scss" scoped>
video {
  position: absolute;
  top: -3%;
  left: 0;
  height: 102%;
  width: auto;
  object-fit: cover;
  z-index: 1;
}

div:hover {
  cursor: pointer;
}
.address {
  position: absolute;
  top: 5%;
  left: 2.5%;
  width: 95%;
  height: auto;
  object-fit: contain;
  z-index: 20;
}
.map-detail {
  position: absolute;
  bottom: 4%;
  left: 0%;
  width: 100%;
  height: auto;
  z-index: 20;

  @media only screen and (max-height: 900px) {
    bottom: 44px;
  }
}
</style>